import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** shield, security. Decorative line icon; always pair with a visible text label. */
export function ShieldIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 2.8l7.2 2.7v5.3c0 4.9-3 7.9-7.2 10.4-4.2-2.5-7.2-5.5-7.2-10.4V5.5L12 2.8z" />
    </IconSvg>
  )
}
